import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SessionTimeoutService } from './core/services/session-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Optwaves Restaurant';
  showLayout = true;

  constructor(
    private router: Router,
    private sessionTimeout: SessionTimeoutService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Hide the app shell for auth, public legal/support routes, and the
        // customer-facing menu-display board (renders full-screen on a monitor).
        this.showLayout =
          !event.url.includes('/auth') &&
          !event.url.includes('/legal') &&
          !event.url.includes('/menu-display');
      });
  }
}
